"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformUTCToTimeWithOffset = void 0;
const date_fns_tz_1 = require("date-fns-tz");
const utcToZonedTimeOrDefault_1 = require("../helpers/utcToZonedTimeOrDefault");
function transformUTCToTimeWithOffset(utcTime, timezone) {
    const zonedTime = (0, utcToZonedTimeOrDefault_1.utcToZonedTimeOrDefault)(utcTime, timezone);
    try {
        return (0, date_fns_tz_1.format)(zonedTime, "yyyy-MM-dd'T'HH:mm:ss.SSSxxx", { timeZone: timezone });
    }
    catch (e) {
        throw new Error(`Invalid date after parsing. Date: "${utcTime}", Timezone: "${timezone}"`);
    }
}
exports.transformUTCToTimeWithOffset = transformUTCToTimeWithOffset;
//# sourceMappingURL=transformUTCToTimeWithOffset.js.map